import preloaded from '../src/preloaded.js';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';
import SearchReducer from '../src/search/reducer.js';
import SearchContainer from '../src/search/SearchContainer.js';
import SearchForm from '../src/search/SearchFormDesktop.js';
import SearchResults from '../src/search/SearchResultsDesktop.js';

const store = createStore(SearchReducer, applyMiddleware(thunk));
const target = document.getElementById('app');

ReactDOM.render(
  <Provider store={store}>
    <SearchContainer
      SearchForm={SearchForm}
      SearchResults={SearchResults}
      initialTerm={preloaded.initial_term}
      initialTermType={preloaded.initial_term_type}
      sports={preloaded.sports}
    />
  </Provider>
, target);
